(() => {
  const lang = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  const TEXTS = {
    de: {
      unavailable: 'Diese Größe ist derzeit nicht verfügbar.',
      next: ' Nächste verfügbare Größe: '
    },
    en: {
      unavailable: 'This size is currently unavailable.',
      next: ' Next available size: '
    },
    fr: {
      unavailable: 'Cette taille est actuellement indisponible.',
      next: ' Prochaine taille disponible : '
    }
  };
  const t = TEXTS[lang] || TEXTS.de;
  const ORDER = ['XS', 'S', 'M', 'L'];
  const idx = (size) => ORDER.indexOf(size);

  const isLongsleevePage = () => Boolean(document.querySelector('.mr-size-chart'));

  // Strategie: Laenge ergibt sich aus der Koerpergroesse, Breite aus dem Gewicht (Schnitt ist schmal).
  const recommend = (height, weight) => {
    if (height <= 168 && weight <= 58) return 'XS';
    const lengthSize = height <= 177 ? 'S' : (height <= 188 ? 'M' : 'L');
    const widthSize = weight <= 66 ? 'S' : (weight <= 78 ? 'M' : 'L');
    const li = idx(lengthSize);
    const wi = idx(widthSize);
    if (li === wi) return lengthSize;
    if (Math.abs(li - wi) === 1) return ORDER[Math.max(li, wi)];
    return 'M';
  };

  const hideStaticNote = () => {
    document.querySelectorAll('.mr-size-note--longsleeve').forEach((node) => {
      node.style.display = 'none';
    });
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || !target.closest || !target.closest('#mr-calc-btn')) return;
    if (!isLongsleevePage()) return;
    event.stopImmediatePropagation();
    event.preventDefault();

    const heightSlider = document.getElementById('mr-height');
    const weightSlider = document.getElementById('mr-weight');
    const resultBox = document.getElementById('mr-size-result');
    const resultSize = document.getElementById('mr-result-size');
    const resultNote = document.getElementById('mr-result-note');
    if (!resultBox || !resultSize || !resultNote) return;

    const height = parseInt(heightSlider ? heightSlider.value : '175', 10);
    const weight = parseInt(weightSlider ? weightSlider.value : '70', 10);
    const size = recommend(height, weight);

    const buttons = Array.from(document.querySelectorAll('.mr-size-btn'));
    const match = buttons.find((btn) => btn.dataset.variantTitle === size);
    const available = Boolean(match && !match.disabled);

    let note = '';
    if (!available) {
      note = t.unavailable;
      for (let i = idx(size) + 1; i < ORDER.length; i += 1) {
        const next = buttons.find((btn) => btn.dataset.variantTitle === ORDER[i] && !btn.disabled);
        if (next) { note += t.next + ORDER[i] + '.'; break; }
      }
    }

    resultSize.textContent = size;
    resultNote.textContent = note;
    resultBox.classList.add('is-visible');
    if (available) match.click();
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideStaticNote);
  else hideStaticNote();
  window.addEventListener('load', hideStaticNote);
})();
